import BaseService from './BaseService';
import {
  IChangeEquipmentResponseData,
  IFetchMyselfResponseData,
  IFetchOutfitResponseData,
  IMyselfService,
  IScrapbookMantelpieceResponseData
} from 'types/myself';

export default class MyselfService extends BaseService implements IMyselfService {
  fetchMyself = () => {
    const config = {
      url: '/character/myself',
    };
    return this.doRequest<IFetchMyselfResponseData>(config);
  };

  /**
   * Fetch Outfit
   * @return {Promise}
   */
  fetchOutfit = () => {
    const config = {
      url: '/outfit',
    };
    return this.doRequest<IFetchOutfitResponseData>(config);
  };

  /**
   * Change Outfit
   * @param  {Number} outfitId
   * @return {Promise}
   */
  changeOutfit = (outfitId: number | null = null) => {
    const config = {
      method: 'post',
      url: '/outfit/change',
      data: { outfitId }
    };
    return this.doRequest<IFetchOutfitResponseData>(config);
  };


  /**
   * Equip Quality
   * @param  {Number} qualityId
   * @return {Promise}
   */
  equipQuality = (qualityId: number | null = null) => {
    const config = {
      method: 'post',
      url: '/outfit/equip',
      data: { qualityId }
    };
    return this.doRequest<IChangeEquipmentResponseData>(config);
  };


  /**
   * Un-Equip Quality
   * @param  {Number} qualityId
   * @return {Promise}
   */
  unequipQuality = (qualityId: number | null = null) => {
    const config = {
      method: 'post',
      url: '/outfit/unequip',
      data: { qualityId }
    };
    return this.doRequest<IChangeEquipmentResponseData>(config);
  };


  /**
   * Choose new scrapbook
   * @param  {Object} item
   * @return {undefined}
   */
  chooseNewScrapbook = (item: { id: number } | null = null) => {
    const config = {
      method: 'post',
      url: `/character/scrapbook/${item?.id ?? null}`,
    };
    return this.doRequest<IScrapbookMantelpieceResponseData>(config);
  };


  /**
   * [chooseNewMantelpiece description]
   * @param  {[type]} [item=null] [description]
   * @return {[type]}             [description]
   */
  chooseNewMantelpiece = (item: { id: number } | null = null) => {
    const config = {
      method: 'post',
      url: `/character/mantelpiece/${item?.id ?? null}`,
    };
    return this.doRequest<IScrapbookMantelpieceResponseData>(config);
  };

  setAvatarImage = ({ avatarImage }: { avatarImage: string }) => {
    const config = {
      method: 'post',
      url: '/character/setavatarimage',
      data: { avatarImage },
    };
    return this.doRequest<any>(config);
  };


  setJournalPrivacy = (isPrivate: boolean) => {
    const config = {
      method: 'post',
      url: `/character/profileprivacy/${isPrivate}`
    };

    return this.doRequest<any>(config);
  }
}
